import { FaChevronLeft, FaChevronRight } from "react-icons/fa"

const Pagination = ({ currentPage, totalPages, selectPage, limitPage, nextPage, prevPage, limit = 10 }) => {
    const current = Number(currentPage) || 1
    const total = Math.max(Number(totalPages) || 1, 1)

    const navBtn = "inline-flex min-h-10 min-w-10 items-center justify-center px-3 text-sm transition-colors duration-tesla"
    const navBtnActive = `${navBtn} text-link`
    const navBtnDisabled = `${navBtn} text-muted-soft cursor-not-allowed`
    const pageBtn = (active) => `${navBtn} rounded-xs ${active
        ? 'pill-active'
        : 'text-ink hover:bg-surface-soft dark:text-white dark:hover:bg-white/5'
    }`

    return (
        <div className="card w-full px-2 py-2 sm:px-3 md:justify-end">
            <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:justify-end">
                <nav aria-label="Rows per page" className="w-full sm:w-auto">
                    <select
                        value={limit}
                        onChange={limitPage}
                        className="h-10 w-full rounded-xs border border-border-strong bg-canvas px-4 text-sm text-ink focus:border-ink focus:outline-none dark:border-white/10 dark:bg-tile-2 dark:text-white sm:w-auto"
                    >
                        <option value="10">10 / halaman</option>
                        <option value="25">25 / halaman</option>
                        <option value="50">50 / halaman</option>
                        <option value="100">100 / halaman</option>
                    </select>
                </nav>
                <nav aria-label="Page navigation" className="w-full overflow-x-auto sm:w-auto">
                    <ul className="inline-flex min-w-full items-center justify-center sm:min-w-0 sm:justify-end">
                        <li>
                            <button
                                type="button"
                                onClick={prevPage}
                                disabled={current <= 1}
                                className={current > 1 ? navBtnActive : navBtnDisabled}
                            >
                                <FaChevronLeft className="text-[10px]" />
                                <span className="ml-1 hidden sm:inline">Prev</span>
                            </button>
                        </li>
                        {current > 6 && (
                            <li>
                                <button
                                    type="button"
                                    onClick={() => selectPage(1)}
                                    className={pageBtn(false)}
                                >
                                    1..
                                </button>
                            </li>
                        )}
                        {(() => {
                            const li = [];
                            const windowSize = 3
                            const start = current > windowSize ? (current - windowSize) : 1
                            const end = current < (total - windowSize) ? current + windowSize : total

                            for (let pageNumber = start; pageNumber <= end; pageNumber++) {
                                li.push(
                                    <li key={pageNumber}>
                                        <button
                                            type="button"
                                            onClick={() => selectPage(pageNumber)}
                                            className={pageBtn(current === pageNumber)}
                                        >
                                            {pageNumber}
                                        </button>
                                    </li>
                                );
                            }

                            return li;
                        })()}
                        {current < (total - 3) && (
                            <li>
                                <button
                                    type="button"
                                    onClick={() => selectPage(total)}
                                    className={pageBtn(false)}
                                >
                                    ...{total}
                                </button>
                            </li>
                        )}
                        <li>
                            <button
                                type="button"
                                onClick={nextPage}
                                disabled={current >= total}
                                className={current < total ? navBtnActive : navBtnDisabled}
                            >
                                <span className="mr-1 hidden sm:inline">Next</span>
                                <FaChevronRight className="text-[10px]" />
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default Pagination;
